import PropTypes from "prop-types";
import React from "react";
import { Badge } from "reactstrap";

const VARIANT_MAP = {
  success: "success",
  danger: "danger",
  warning: "warning",
  info: "info",
  primary: "primary",
  secondary: "secondary",
};

/**
 * Semantic status badge for table cells.
 */
const StatusBadge = ({ status, variant, children }) => {
  const v = variant || VARIANT_MAP[status?.toLowerCase?.()] || "secondary";
  return (
    <Badge color={v} className="status-badge">
      {children ?? status}
    </Badge>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string,
  variant: PropTypes.oneOf(["success", "danger", "warning", "info", "primary", "secondary"]),
  children: PropTypes.node,
};

export default StatusBadge;
